<!-- ! V3 免息券 -->
<template>
  <div class="page coupon-detail">
    <navigation>优惠券详情</navigation>
    <div class="item">
      <div class="center">
        <span class="description" v-if="item.leftTopCopyWriting">{{ item.leftTopCopyWriting }}</span>
        <span class="title"> 免息券 </span>
        <span class="wapper" v-if="item.cashbackStatusMark === 'Y'">
          <span class="amount">
            {{ item.amt }}
          </span>
          <span class="unit">元</span>
        </span>
        <span class="wapper" v-else>
          <span class="amount">
            {{ item.value }}
          </span>
          <span class="unit"> {{item.discountType === 'FREE_AMOUNT'? '元':'天'}} </span>
        </span>
      </div>
      <div class="bottom">
        <span class="valid-time"></span>
        <span class="intrest-day" style="padding-right:0">{{ item.rightBottomCopyWriting }}</span>
      </div>
    </div>

    <div class="content">
      <div class="row">
        <div class="left-title">优惠类型</div>
        <div class="right-title">免息券</div>
      </div>

      <div class="row">
        <div class="left-title">有效期</div>
        <div class="right-title">
          {{ item.validTime | formateTime }}
        </div>
      </div>
      <div class="row">
        <div class="left-title">优惠</div>
        <div class="right-title">
          <template v-if="item.cashbackStatusMark === 'Y'">
            <span class="amount">
              {{ item.amt  }}
            </span>

            <span class="unit"> 元 </span>
          </template>
          <template v-else>
            <span class="amount">
              {{ item.value  }}
            </span>

            <span class="unit"> {{item.discountType === 'FREE_AMOUNT'? '元':'天'}} </span>
          </template>
        </div>
      </div>
      <div class="row">
        <div class="left-title">用券说明</div>
        <div class="right-title"></div>
      </div>
      <div class="description" v-html="item.ruleDesc"></div>
    </div>

    <div class="footer">
      <nd-button class="btn" @click="goActivitiesBank" :disabled="item.finalStatusMark==='Y'" >
        {{item.finalStatusMark==='Y'?'优惠已使用': '使用优惠券'}}
      </nd-button>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'quan-detail',
  customReadyNotify: true,
  data () {
    return {
      couponRecordId: this.$route.query.couponRecordId || '',
      item: {}
    }
  },
  async created () {
    await this.getCouponDetail()
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('activities', ['couponDetailX']),

    async getCouponDetail () {
      const res = await this.couponDetailX({
        couponRecordId: this.couponRecordId
      })
      if (res.success) {
        this.item = res.data?.couponV3DTO || {}
      }
    },
    goActivitiesBank () {
      if (this.item.cashbackStatusMark === 'N') {
        this.$message(`请参考券说明，满足使用条件后才可使用`)
        return
      }
      this.$router.push(
        `/activities/band?couponRecordId=${this.item.couponId}&couponV3=Y`
      )
    }
  }
}
</script>

<style lang="less" src="./style.less"></style>
@import "../../assets/less/mixin.less";

